module.exports = __webpack_public_path__ + "media/images/sb_favicon-b4fbe745735b6f6479c480aab2d1a1e1.jpg";